import { roundAwayFromZero } from "~/utils/round-away-from-zero";

import { getLineAllowanceDeductionInclVat } from "./get-line-allowance-deduction";
import { type KioskDisplayBasketItem } from "./types";

type KioskBasketTotals = {
  unitTotalPriceInclVat: number;
  unitTotalPriceExclVat: number;
  unitTotalDepositInclVat: number;
  unitTotalDepositExclVat: number;
  unitTotalPayableInclVat: number;
  unitTotalAllowanceDeductionInclVat: number;
};

/**
 * The price totals cover products only, so the tax rows and the payload's tax
 * total stay derivable from them. `unitTotalPayableInclVat` is what is charged.
 */
export function sumKioskBasketTotals(
  items: KioskDisplayBasketItem[]
): KioskBasketTotals {
  const unitTotalPriceInclVat = roundAwayFromZero(
    items.reduce((acc, item) => acc + item.unitTotalPriceInclVat, 0)
  );

  // Deposits are whole minor units by definition, so there is nothing to round.
  const unitTotalDepositInclVat = items.reduce(
    (acc, item) => acc + item.depositTotalInclVat,
    0
  );

  return {
    unitTotalPriceInclVat,
    unitTotalPriceExclVat: items.reduce(
      (acc, item) => acc + roundAwayFromZero(item.unitTotalPriceExclVat),
      0
    ),
    unitTotalDepositInclVat,
    unitTotalDepositExclVat: items.reduce(
      (acc, item) => acc + item.depositTotalExclVat,
      0
    ),
    unitTotalPayableInclVat: unitTotalPriceInclVat + unitTotalDepositInclVat,
    unitTotalAllowanceDeductionInclVat: roundAwayFromZero(
      items.reduce(
        (acc, item) => acc + getLineAllowanceDeductionInclVat(item),
        0
      )
    )
  };
}
